/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Board_Write_SentInputs */

const en_us2_board_write_sent = /** @type {(inputs: Board_Write_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Received. Once the team approves it, it shows up on the board.`)
};

const pt_br2_board_write_sent = /** @type {(inputs: Board_Write_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recebido. Assim que a equipe aprovar, aparece no mural.`)
};

const pt_pt2_board_write_sent = /** @type {(inputs: Board_Write_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recebido. Assim que a equipe aprovar, aparece no mural.`)
};

/** @type {(inputs: Board_Write_SentInputs) => LocalizedString} */
const es_419_board_write_sent = en_us2_board_write_sent;

/** @type {(inputs: Board_Write_SentInputs) => LocalizedString} */
const fr_fr2_board_write_sent = en_us2_board_write_sent;

/** @type {(inputs: Board_Write_SentInputs) => LocalizedString} */
const de_de2_board_write_sent = en_us2_board_write_sent;

/** @type {(inputs: Board_Write_SentInputs) => LocalizedString} */
const it_it2_board_write_sent = en_us2_board_write_sent;

/**
* | output |
* | --- |
* | "Received. Once the team approves it, it shows up on the board." |
*
* @param {Board_Write_SentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const board_write_sent = /** @type {((inputs?: Board_Write_SentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Board_Write_SentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_board_write_sent(inputs)
	if (locale === "es-419") return es_419_board_write_sent(inputs)
	if (locale === "pt-PT") return pt_pt2_board_write_sent(inputs)
	if (locale === "fr-FR") return fr_fr2_board_write_sent(inputs)
	if (locale === "de-DE") return de_de2_board_write_sent(inputs)
	if (locale === "it-IT") return it_it2_board_write_sent(inputs)
	return en_us2_board_write_sent(inputs)
});
export { board_write_sent as "board.write_sent" }